import { throwCaptured } from '../../../utils'

import { ConnectwareError, ConnectwareErrorType } from '../../../domain'

import { isAbsoluteRoutePathWithId, isAbsoluteRoutePathWithServiceAndResourceId, isAbsoluteRoutePathWithServiceId, type RouterState } from './Domain'
import { useConnectwareRouting } from './Router.State'

const createStateChecker =
    <T>(isEnumOf: (v: unknown) => v is T) =>
    (state: RouterState): state is Extract<RouterState, { path: T }> =>
        isEnumOf(state.path)

const isAbsoluteRoutePathWithResourceIdState = createStateChecker(isAbsoluteRoutePathWithId)
const isAbsoluteRoutePathWithServiceIdState = createStateChecker(isAbsoluteRoutePathWithServiceId)
const isAbsoluteRoutePathWithServiceAndResourceIdState = createStateChecker(isAbsoluteRoutePathWithServiceAndResourceId)

export const useId = (): string => {
    const state = useConnectwareRouting()

    if (isAbsoluteRoutePathWithResourceIdState(state) || isAbsoluteRoutePathWithServiceAndResourceIdState(state)) {
        return state.resourceId
    }

    if (isAbsoluteRoutePathWithServiceIdState(state)) {
        return state.serviceId
    }

    return throwCaptured(new ConnectwareError(ConnectwareErrorType.STATE, 'Id not retrievable under this route', state), useId)
}
